import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { KPI } from '../../../@core/api';
import { ChartFiltersService } from '../../../@core/utils';

import { FormsModule } from '@angular/forms';
import { NbRadioModule } from '@nebular/theme';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-budget-or-ratio-filter',
    templateUrl: './budget-or-ratio-filter.component.html',
    styleUrls: ['./budget-or-ratio-filter.component.scss'],
    standalone: true,
    imports: [NbRadioModule, FormsModule, TranslateModule, NgClass]
})
export class BudgetOrRatioFilterComponent implements OnInit, OnDestroy {

  @Input() public justifyContentRight: boolean = false;

  public budgetOrRatioFilterOptions = [
    {
      value: KPI.BudgetOrRatioFilter.TRAJECTORY_ONLY,
      label: this.translate.instant('Trajectory only'),
    },
    {
      value: KPI.BudgetOrRatioFilter.CAPEX_AMOUNT,
      label: this.translate.instant('With CAPEX amount'),
    },
  ];
  public budgetOrRatioFilter: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private chartFiltersService: ChartFiltersService,
    private translate: TranslateService,
  ) {
  }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.chartFiltersService.filter$('budgetOrRatio').pipe(
        first()
      ).subscribe((budgetOrRatioFilter) =>
        this.budgetOrRatioFilter = <number>budgetOrRatioFilter
      ),
    );
  }

  public budgetOrRatioFilterChanged(): void {
    setTimeout(() => {
      this.chartFiltersService.setFilter('budgetOrRatio', this.budgetOrRatioFilter);
    }, 50);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
